import axios from './axios';

export const getSignUrl = () => axios.post('/money-api/zoho-sign/get-sign-url');
